export default __webpack_public_path__ + "images/ba5cda524c5ea14a93fe4134f884eb7d-Eventbrite_NYE_HomepageC_1920x544.webp";